import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CasesComponent } from './pages/cases/cases.component';
import { CaseComponent } from './pages/case/case.component';
import { CaseCreationComponent } from './pages/case-creation/case-creation.component';
import { ProvisionalControlComponent } from '../schedule/pages/provisional-control/provisional-control.component';
import { tenantRouteGuard } from '../../tenant-config/tenant-route.guard';

const routes: Routes = [
   {
      path: '',
      redirectTo: 'listado',
      pathMatch: 'full',
      data: { breadcrumb: 'Listado' }
      // Protect all other child routes at one time instead of adding the AuthGuard to each route individually.
      // canActivateChild: [AuthGuard],
   },
   {
      path: 'listado',
      //component: CasesComponent
      component: ProvisionalControlComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Listado', tenantRoute: '/app/casos/listado' }
      // Protect all other child routes at one time instead of adding the AuthGuard to each route individually.
      // canActivateChild: [AuthGuard],
   },
   {
      path: 'listado/:id',
      component: CaseComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Listado >:id', tenantRoute: '/app/casos/listado/:id' }
      // Protect all other child routes at one time instead of adding the AuthGuard to each route individually.
      // canActivateChild: [AuthGuard],
   },
   {
      path: 'creacion',
      component: CaseCreationComponent,
      canActivate: [tenantRouteGuard],
      data: { breadcrumb: 'Creación', tenantRoute: '/app/casos/creacion' }
   },
];

@NgModule({
   imports: [RouterModule.forChild(routes)],
   exports: [RouterModule],
})
export class CasesRoutingModule { }
